import React from "react";

import styles from "./styles.scss";

import CSSModules from "react-css-modules";

import { getIconByMimeType } from "Portal/NewPortal/Shared/getFileIconAndExtension";

import FileViewer from "components/Global/Modals/FileViewer";
import FileViewerWrapper from "components/Global/Modals/FileViewer/Wrapper";

import { noop, isEmptyOrNil } from "utils/General";

const File = ({ data = {}, showModal }) => {
  if (!data?.id) {
    return null;
  }

  const handleViewFile = file => {
    const newFile = {
      ...file,
      url: file?.file_url || "",
      mimetype: file?.mimetype || "external"
    };

    if (newFile.mimetype === "external") {
      window.open(newFile.url, "_blank");
    } else {
      const filesToView = [newFile];
      showModal({
        content: <FileViewer start={0} files={filesToView} isReadOnly />,
        wrapper: FileViewerWrapper
      });
    }
  };

  const {
    mimetype,
    label = null,
    file_url = null,
    description = "File Description"
  } = data || {};

  const mimetypeCheck = isEmptyOrNil(mimetype) ? "external" : mimetype;

  const Icon = getIconByMimeType(mimetypeCheck);

  return (
    <div
      styleName="fileContainer"
      className={!isEmptyOrNil(file_url) ? "accentable-hover" : ""}
      onClick={!isEmptyOrNil(file_url) ? () => handleViewFile(data) : noop}
    >
      <div styleName="fileIcon">{Icon && <Icon />}</div>
      <div styleName="fileDataContainer">
        <div styleName="fileTitle">{label}</div>
        <div styleName="fileDescription">{description}</div>
      </div>
    </div>
  );
};

export default CSSModules(File, styles);
